(function (root) {
  'use strict';
  var MESSAGE = "I've joined Reminders by Fig & Bloom. It helps me keep track of birthdays and important dates. Thought you might like it too:";
  function safeUrl(value) {
    try {
      var url = new root.URL(value, root.location && root.location.origin || 'https://figandbloom.com');
      return (url.origin === 'https://figandbloom.com' || root.location && url.origin === root.location.origin) && url.pathname === '/pages/reminders' && url.searchParams.get('reminder_view') === 'join' && /^[a-f0-9]{32}$/.test(url.searchParams.get('token') || '') ? url.href : null;
    } catch (_) { return null; }
  }
  function mount(element, options) {
    options = options || {};
    var nodes = {};
    ['open', 'panel', 'message', 'copy', 'share', 'status'].forEach(function (key) { nodes[key] = element.querySelector('[data-invitation-' + key + ']'); });
    var url = safeUrl(options.url), busy = false;
    var message = url ? (options.message || MESSAGE) + '\n' + url : '';
    function reset() {
      nodes.panel.hidden = true; nodes.open.hidden = false;
      nodes.message.value = message; nodes.status.textContent = '';
      nodes.copy.disabled = !url; nodes.share.hidden = !(url && root.navigator && typeof root.navigator.share === 'function');
    }
    function open() {
      nodes.panel.hidden = false; nodes.open.hidden = true;
      if (!url) nodes.status.textContent = 'Your invitation is unavailable. Reload the page and try again.';
      nodes.message.focus();
    }
    function manual() {
      nodes.status.textContent = 'Select the invitation above and copy it into your message.';
      nodes.message.focus(); nodes.message.select();
    }
    async function handoff(method) {
      if (busy || !url) return;
      busy = true; nodes.copy.disabled = true; nodes.share.disabled = true; nodes.status.textContent = '';
      try {
        if (method === 'native') {
          await root.navigator.share({ title: 'Join Reminders', text: options.message || MESSAGE, url: url });
          nodes.status.textContent = 'Invitation opened in your sharing app.';
        } else {
          if (!root.navigator || !root.navigator.clipboard || typeof root.navigator.clipboard.writeText !== 'function') { manual(); return; }
          await root.navigator.clipboard.writeText(message);
          nodes.status.textContent = 'Invitation copied. Paste it into your message.';
        }
        if (options.onHandoff) options.onHandoff(method);
      } catch (error) {
        if (!error || error.name !== 'AbortError') manual();
      } finally { busy = false; nodes.copy.disabled = !url; nodes.share.disabled = false; }
    }
    var copy = function () { return handoff('copy'); }, share = function () { return handoff('native'); };
    nodes.open.addEventListener('click', open); nodes.copy.addEventListener('click', copy); nodes.share.addEventListener('click', share);
    reset();
    return { open: open, reset: reset, destroy: function () { nodes.open.removeEventListener('click', open); nodes.copy.removeEventListener('click', copy); nodes.share.removeEventListener('click', share); } };
  }
  root.FBRemindersInvitation = { mount: mount };
})(typeof window !== 'undefined' ? window : globalThis);
